import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header";
import {
  getWatiCredentials,
  setWatiCredentials,
  syncContactsToWati,
  WatiCredentials,
  WatiSyncResult,
} from "../../../api/wati"; // <-- adjust path
import { toast } from "react-toastify";
 
const WhatsAppSettings = () => {
  const [watiCreds, setWatiCreds] = useState<WatiCredentials | null>(null);
  const [loading, setLoading] = useState(false);
  const [apiEndpoint, setApiEndpoint] = useState("");
  const [apiToken, setApiToken] = useState("");
  const [saving, setSaving] = useState(false);
  const [syncing, setSyncing] = useState(false);
 
  // Test message modal states
  const [testPhone, setTestPhone] = useState("");
  const [testMessage, setTestMessage] = useState("This is a test message from CRM");
  const [sending, setSending] = useState(false);
 
  // Load credentials on mount
  useEffect(() => {
    fetchCredentials();
  }, []);
 
  const fetchCredentials = async () => {
    try {
      setLoading(true);
      const creds = await getWatiCredentials();
      setWatiCreds(creds);
      setApiEndpoint(creds.api_endpoint || "");
      setApiToken(creds.api_token || "");
    } catch {
      // handled in service
    } finally {
      setLoading(false);
    }
  };
 
  const handleSaveCredentials = async () => {
    try {
      setSaving(true);
      await setWatiCredentials(apiEndpoint, apiToken);
      toast.success("Credentials saved successfully");
      fetchCredentials();
    } catch {
      // handled in service
    } finally {
      setSaving(false);
    }
  };
 
  const handleSyncContacts = async () => {
    try {
      setSyncing(true);
      const result: WatiSyncResult = await syncContactsToWati();
      toast.success(
        `Synced: ${result.synced.length}, Skipped/Failed: ${result["skipped/failed"].length}`
      );
    } catch {
      // handled in service
    } finally {
      setSyncing(false);
    }
  };
 
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      <i className="ti ti-brand-whatsapp text-primary me-2" />
                      WhatsApp Settings
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
 
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <h4 className="fs-20">
                           <i className="ti ti-brand-whatsapp text-success me-2" />WATI - WhatsApp Integration</h4>
                      </div>
 
                      <div className="column">
                        <div className="col-md-12">
                          {/* WATI Integration */}
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/Whatsapp Cloud.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      WATI WhatsApp API
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/gateway-03.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      Twilio
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/vonage.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      Vonage
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/Gupshup.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      Gupdshup
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/MessageBird.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                     MessageBird
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/360dialog.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      360dialog
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/infobip.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      infobip
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/gallabox.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      Gallabox
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="border rounded p-3 mb-4">
                            <div className="row gy-3">
                              <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                  <span className="avatar avtar-lg border me-2 flex-shrink-0">
                                    <ImageWithBasePath
                                      src="assets/img/icons/AiSensy.svg"
                                      className="w-auto h-auto"
                                      alt=""
                                    />
                                  </span>
                                  <div>
                                    <h6 className="fw-medium mb-1 d-flex align-items-center">
                                      {/* <i className="ti ti-brand-whatsapp text-success me-2" /> */}
                                      AiSensy
                                    </h6>
                                    <span
                                      className={`badge ${watiCreds?.Status === "Connected"
                                          ? "bg-soft-success"
                                          : "bg-soft-purple text-purple"
                                        }`}
                                    >
                                      {watiCreds?.Status || "Not Connected"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#wati_settings"
                                  >
                                    <i className="ti ti-plug-connected me-1" />{" "}
                                    {watiCreds?.Status === "Connected"
                                      ? "View / Update"
                                      : "Connect Now"}
                                  </Link>
                                  <button
                                    className="btn btn-light"
                                    onClick={handleSyncContacts}
                                    disabled={!watiCreds || syncing}
                                  >
                                    {syncing ? (
                                      <i className="ti ti-loader-2 me-1 spinner-border" />
                                    ) : (
                                      <i className="ti ti-refresh me-1" />
                                    )}
                                    {syncing ? "Syncing..." : "Sync Contacts"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
 
      {/* WATI Credentials Modal */}
      <div className="modal fade" id="wati_settings" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">WATI Credentials</h5>
              <button
                className="btn-close custom-btn-close border p-1 me-0 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">API Endpoint</label>
                <input
                  type="text"
                  className="form-control"
                  value={apiEndpoint}
                  onChange={(e) => setApiEndpoint(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">API Token</label>
                <input
                  type="text"
                  className="form-control"
                  value={apiToken}
                  onChange={(e) => setApiToken(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveCredentials}
                disabled={saving}
                data-bs-dismiss="modal"
              >
                {saving ? "Saving..." : "Save & Verify"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default WhatsAppSettings;
 